<template>
    <b-modal id="facility_delete" ref="facility_delete" header-class="no-border" footer-class="no-border"
             @hidden="resetForm" :title="setTitle">
        <b-row v-if="validationError" class="mb-2">
            <b-colxx md="12">
                <b-alert class="text-center" show variant="danger"
                         v-text="validationError"/>
            </b-colxx>
        </b-row>

        <span>
            You can't revert back your action if you delete this data. For further query, contact Database Manager!
        </span>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('facility_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'facility'" variant="danger" :click="deleteFacility">Delete</state-button>

            <state-button size="sm" v-if="mode === 'comment'" variant="danger" :click="deleteComment">Delete</state-button>

            <state-button size="sm" v-if="mode === 'contract'" variant="danger" :click="deleteContract">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "FacilityDeleteModal",

        components: {
            StateButton,
        },

        props: [
            'facility', 'data', 'mode',
        ],

        data() {
            return {
                validationError: null
            }
        },

        computed: {
            setTitle() {
                if (this.mode === 'facility') {
                    return 'Delete ' + this.facility.data.attributes.name + '?';
                } else if (this.mode === 'comment'){
                    return 'Delete comment?';
                } else if (this.mode === 'contract'){
                    return 'Delete contract?';
                }
            },
        },

        methods: {
            deleteFacility() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteFacility', this.facility)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-facility');

                                this.$notify('error filled', 'Success!', 'Deleted the facility!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            deleteComment() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteFacilityComment', this.data)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-comment');

                                this.$notify('error filled', 'Success!', 'Deleted the comment!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            deleteContract() {
                console.log(this.data);
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteFacilityContract', this.data)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-contract');

                                this.$notify('error filled', 'Success!', 'Deleted the contract!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            resetForm() {
                this.$emit('close');

                this.validationError = null;
            }
        },
    }
</script>

<style scoped>

</style>
